import React from 'react';

import styled from 'styled-components';

const MessageCard = styled.div`
  border: 1px solid var(--line-gray);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
`;

const MessageHeader = styled.button`
  width: 100%;
  border: 0;
  padding: 6px 16px;
  background: var(--surface-muted-dark);
  color: var(--white);
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  text-align: left;
`;

const HeaderText = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
`;

const ToggleIconButton = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  min-width: 24px;
  height: 24px;
  cursor: pointer;
`;

const ToggleIcon = styled.img`
  width: 24px;
  height: 24px;
  transform: rotate(-90deg);
  transition: transform 0.15s ease;

  &.expanded {
    transform: rotate(0deg);
  }
`;

const ChannelBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--active-blue);
  width: 46px;
  height: 16px;
  color: var(--white);
  border-radius: 10px;
  font-size: 9px;
  line-height: 1;
`;

const HeaderHeadline = styled.span`
  color: var(--white);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DelayLabel = styled.span`
  font-family: var(--font-bold);
`;

const EditButton = styled.span`
  margin-left: auto;
  color: var(--white);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 2px;
`;

const MessageBody = styled.div`
  color: var(--text-primary);
`;

const SubjectRow = styled.div`
  padding: 10px 18px;
  border-top: 1px solid var(--line-gray);
  font-size: 12px;
`;

const SubjectLabel = styled.span`
  font-family: var(--font-bold);
`;

const BodyText = styled.div`
  padding: 20px 87px 30px;
  border-top: 1px solid var(--line-gray);
  background: var(--background);
  font-family: inherit;
  font-size: 12px;
  line-height: 1.65;
  color: var(--text-secondary);
  white-space: pre-wrap;
`;

type Props = {
  delayLabel: string;
  subject: string;
  content: string;
  isExpanded: boolean;
  onToggle: () => void;
  onEdit?: () => void;
};

const ActionPlanEmailCampaignMessage = ({ delayLabel, subject, content, isExpanded, onToggle, onEdit }: Props) => (
  <MessageCard>
    <MessageHeader onClick={onToggle}>
      <ToggleIconButton
        onClick={(event) => {
          event.stopPropagation();
          onToggle();
        }}
      >
        <ToggleIcon
          className={isExpanded ? 'expanded' : 'collapsed'}
          src="/icons/dropdown-caret-down-white.svg"
          alt={isExpanded ? 'collapse message' : 'expand message'}
        />
      </ToggleIconButton>
      <HeaderText>
        <ChannelBadge>EMAIL</ChannelBadge>
        <HeaderHeadline>
          <DelayLabel>{delayLabel}</DelayLabel>
        </HeaderHeadline>
      </HeaderText>
      <EditButton
        onClick={(event) => {
          event.stopPropagation();
          onEdit?.();
        }}
      >
        <img src="/icons/edit-white.svg" width={16} height={16} alt="edit message" />
      </EditButton>
    </MessageHeader>
    <MessageBody>
      <SubjectRow>
        <SubjectLabel>Subject:</SubjectLabel> {subject}
      </SubjectRow>
      {isExpanded ? <BodyText>{content}</BodyText> : null}
    </MessageBody>
  </MessageCard>
);

export default ActionPlanEmailCampaignMessage;

